import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useGetContentEntityTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { ContentEntityTypeFormBuilder } from './ContentEntityTypeFormBuilder';

interface ContentEntityTypeEditFormProps {
  onSubmit: (collectionComponentTypeId: number) => void;
  onCancel: () => void;
}

export const ContentEntityTypeEditForm = ({
  onSubmit,
  onCancel,
}: ContentEntityTypeEditFormProps) => {
  const contentEntityTypeByIdMultilingual =
    useGetContentEntityTypeByIdMultilingual();

  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Edit Type'}`}
          origintext="Edit Type"
        />
      </h1>
      <div className="mt-6">
        {contentEntityTypeByIdMultilingual.data && (
          <ContentEntityTypeFormBuilder
            type="Edit"
            onSubmit={onSubmit}
            onCancel={onCancel}
            data={contentEntityTypeByIdMultilingual.data}
          />
        )}
      </div>
    </div>
  );
};
